import { List, ListItem, ListItemButton } from "@mui/material";
import { Link } from "react-router";

export type LinkableItem = {
    id: string;
    featureId: string;
    feature: { layerId: string };
};

export type LinkableItemListProps<T extends LinkableItem> = {
    items: T[];
    renderCard: (item: T) => React.ReactNode;
} & (
    | {
          clickable: true;
          createTo: (item: T) => string;
      }
    | {
          clickable?: false;
          createTo?: (item: T) => string;
      }
);

export default function LinkableItemList<T extends LinkableItem>({
    clickable = false,
    createTo,
    items,
    renderCard,
}: LinkableItemListProps<T>) {
    return (
        <List sx={{ padding: 0, display: "flex", flexDirection: "column", rowGap: 2 }}>
            {items.map(item => {
                return clickable && createTo !== undefined ? (
                    <ListItemButton
                        key={item.id}
                        component={Link}
                        relative="path"
                        to={createTo(item)}
                        // Note: This prevents native link dragging, so text inside the card can be selected
                        draggable={false}
                        sx={{ padding: 0 }}
                    >
                        {renderCard(item)}
                    </ListItemButton>
                ) : (
                    <ListItem key={item.id} sx={{ padding: 0 }}>
                        {renderCard(item)}
                    </ListItem>
                );
            })}
        </List>
    );
}
